// extracted by mini-css-extract-plugin
module.exports = {"root":"N6Vyl","wrapper":"_3-Dmi","heading":"_1eXME","subHeading":"_1DIgL"};